import React from 'react';
import { Container, Card, Button, Row, Col } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { 
  FaEnvelope, 
  FaAd, 
  FaSignOutAlt,
  FaEdit,
  FaHeart,
  FaUserMinus
} from 'react-icons/fa';
import './Profile.css';
import BackToHome from '../components/BackToHome';

const Profile = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      toast.success('Logged out successfully');
      navigate('/login');
    } catch (error) {
      toast.error('Failed to log out');
    }
  };

  const getUserInitial = (user) => {
    if (!user) return '';
    const name = user.displayName || user.email;
    return name.charAt(0).toUpperCase();
  };

  return (
    <Container className="profile-page-container">
      <BackToHome />
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <Card className="profile-card">
            {/* Profile Header with Gradient */}
            <div className="profile-header">
              <div className="profile-avatar-wrapper">
                <div className="profile-avatar">
                  <span className="profile-initial">{getUserInitial(currentUser)}</span>
                </div>
              </div>
              <div className="profile-info">
                <h2 className="profile-name">{currentUser.displayName || 'User'}</h2>
                <p className="profile-email">
                  <FaEnvelope className="me-2" />
                  {currentUser.email}
                </p>
              </div>
            </div>

            <Card.Body className="profile-body">
              <div className="profile-actions">
                <Button 
                  variant="primary"
                  className="profile-action-btn"
                  onClick={() => navigate('/chats')}
                >
                  <div className="btn-icon-wrapper">
                    <FaEnvelope />
                  </div>
                  <div className="btn-text">
                    <span className="btn-title">Messages</span>
                    <span className="btn-subtitle">View your conversations</span>
                  </div>
                </Button>

                <Button 
                  variant="success"
                  className="profile-action-btn"
                  onClick={() => navigate('/my-ads')}
                >
                  <div className="btn-icon-wrapper">
                    <FaAd />
                  </div>
                  <div className="btn-text">
                    <span className="btn-title">My Ads</span>
                    <span className="btn-subtitle">Manage your listings</span>
                  </div>
                </Button>

                <Button 
                  variant="info"
                  className="profile-action-btn"
                  onClick={() => navigate('/favourites')}
                >
                  <div className="btn-icon-wrapper">
                    <FaHeart />
                  </div>
                  <div className="btn-text">
                    <span className="btn-title">Favourites</span>
                    <span className="btn-subtitle">Your saved ads</span>
                  </div>
                </Button>

                <Button 
                  variant="secondary"
                  className="profile-action-btn"
                  onClick={() => navigate('/edit-profile')}
                >
                  <div className="btn-icon-wrapper">
                    <FaEdit />
                  </div>
                  <div className="btn-text">
                    <span className="btn-title">Edit Profile</span>
                    <span className="btn-subtitle">Update your information</span>
                  </div>
                </Button>

                <div className="profile-divider"></div>

                <Link 
                  to="/delete-account" 
                  className="profile-action-btn profile-action-link profile-delete-account-btn"
                >
                  <div className="btn-icon-wrapper">
                    <FaUserMinus />
                  </div>
                  <div className="btn-text">
                    <span className="btn-title">Delete account</span>
                    <span className="btn-subtitle">Permanently delete your account and all data</span>
                  </div>
                </Link>

                <Button 
                  variant="danger"
                  className="profile-action-btn profile-logout-btn"
                  onClick={handleLogout}
                >
                  <div className="btn-icon-wrapper">
                    <FaSignOutAlt />
                  </div>
                  <div className="btn-text">
                    <span className="btn-title">Logout</span>
                    <span className="btn-subtitle">Sign out of your account</span>
                  </div>
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Profile;